import React, { Component } from 'react';
import { musicDirectorActions } from 'redux/actions/music-director-action';
import { connect } from 'react-redux';
import Select from 'react-select';
import ReactLoading from 'react-loading';
import Wavesurfer from 'react-wavesurfer';
import play from "assets/img/play.png";
import texticon from "assets/img/text.png";
import pause from "assets/img/pause.png";
import Profile_Icon from "assets/img/Profile-Icon.png";
import { confirmAlert } from 'react-confirm-alert';
import {
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";


window.WaveSurfer = require("wavesurfer.js");
var dateFormat = require('dateformat');
var moment = require("moment");
// done remove momentDurationFormatSetup for warning optimization
var momentDurationFormatSetup = require("moment-duration-format");
var isEqual = require('lodash.isequal');
var FileSaver = require('file-saver');
var JSZip = require('jszip');
var JSZipUtils = require('jszip-utils');

class AdjudicatorCommentsPage extends Component{
  constructor(props){
    super(props);
  
    this.state = {
      adjudicators:[],
      page:0,
      total_page:0,
      recordings:[],
      countRecording:0,
      selectedOption: null,
      musicDirector :{
        musicDirector_id:this.props.musicDirector.id,
        username:this.props.musicDirector.username,
        request_type:'web'
      },
      selectedAdjudicatorRecording:{
        musicDirector_id:this.props.musicDirector.id,
        adjudicator_id:'',
        request_type:'web'
      },
      playing:[],
      pos:[],
      durationAudio:[],
      recordingNotFound:true,
      getRecordingApi:false
    };

    this.handleChange       = this.handleChange.bind(this);
    this.handleTogglePlay   = this.handleTogglePlay.bind(this);
    this.handlePosChange    = this.handlePosChange.bind(this);
    this.handleFinish       = this.handleFinish.bind(this);
    this.handleLoadingAudio = this.handleLoadingAudio.bind(this);
    this.getNextPageData    = this.getNextPageData.bind(this);
    this.showAllComments    = this.showAllComments.bind(this);
    this.downloadFile       = this.downloadFile.bind(this);
    this.downloadAllFiles   = this.downloadAllFiles.bind(this);
    this.showModalBox       = this.showModalBox.bind(this);
  };

  urlToPromise(url) {
    return new Promise(function(resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
          if(err) {
              reject(err);
          } else {
              resolve(data);
          }
      });
    });
  }
  downloadAllFiles(){
    var zip   = new JSZip();

    const { selectedOption } = this.state;
    const recordingTemp = {...this.state.recordings};
   
    var recordingTempKeys = Object.keys(recordingTemp);
    var recordingTempLen = recordingTempKeys.length;

    this.state.recordings.map((prop,key)=>{
      this.urlToPromise(prop['comment_url']);
      // console.log('comments url',prop['comment_url']);
      //JSZipUtils.getBinaryContent(prop['comment_url'], function (err, data){
        //if(err) {
          //throw err;
        //}

        var extension = null;
        if(prop['comment_url'].includes('.mp4'))
          extension = '.mp4';
        if(prop['comment_url'].includes('.m4a'))
          extension = '.m4a';

        if (extension) {
          var temp = key+1;
          // console.log('test', temp+extension);
          zip.file(temp+extension, this.urlToPromise(prop['comment_url']), {base64:true,binary:true});
          extension = null;
        }
        if(key+1 === recordingTempLen){
          // console.log('if key', key);
          zip.generateAsync({type:"blob"})
          .then(function(content) {
            FileSaver.saveAs(content, selectedOption?selectedOption['first_name'].concat('_', selectedOption['last_name']):'All'+".zip");
          });
        }
      //});
    });

    // console.log('test');
  }
  downloadFile(recUrl, adjudicatorName) {
    var extension = null;
    if(recUrl.includes('.mp4'))
      extension = '.mp4';
    if(recUrl.includes('.m4a'))
      extension = '.m4a';
    FileSaver.saveAs(recUrl,adjudicatorName+extension);
  }
  
  showModalBox(id,info){
  	confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Comments</h3>
              <div className='modalFix'>
              <div className="marginFromTopPopUp" dangerouslySetInnerHTML={{ __html: info }} />
              
              </div>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>Close</button>
                {/* <button onClick={() => {
                    this.updateCommentMusicDirector(id, info)
                    onClose()
                }}>Yes</button> */}
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  showAllComments(){
    const adjudicatorRecordings = {...this.state.selectedAdjudicatorRecording};
    adjudicatorRecordings['adjudicator_id'] = '';
    this.setState({selectedAdjudicatorRecording: adjudicatorRecordings}, function(){
      this.setState({selectedOption: null}, function(){
        this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
      });
    });
  }
  getNextPageData(page){
    this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, page);
  }
  handleLoadingAudio(e, num){
    const durationTemp = {...this.state.durationAudio};
    durationTemp[num] = e.wavesurfer.backend.buffer.duration;
    this.setState({durationAudio:durationTemp});
  }
  handleFinish(e, num){
    const playingTemp = {...this.state.playing};
    playingTemp[num] = false;
    this.setState({playing: playingTemp}, function(){
      const posTemp = {...this.state.pos};
      posTemp[num] = 0;
      this.setState({pos: posTemp});
    });
  }
  handleTogglePlay(num) {
    const playingTempNew = {...this.state.playing};
   
    var playingTempNewKeys = Object.keys(playingTempNew);
    var playingTempNewLen = playingTempNewKeys.length;

    for(var i = 0 ; i < playingTempNewLen; i++){
      if (playingTempNew[i] && (i !== num) ){
        playingTempNew[i] = false;
      }
    }

    this.setState({playing: playingTempNew}, function(){
      const playingTemp = {...this.state.playing};
      playingTemp[num] = !playingTemp[num];
      this.setState({playing: playingTemp});
    });
  }
  handlePosChange(e, num) {
    const posTemp = {...this.state.pos};
    posTemp[num] = e.originalArgs[0];
    this.setState({pos: posTemp});
  }
  handleChange(selectedOption) {
    this.setState({ selectedOption }, function(){
      // if ( selectedOption ) {
        const adjudicatorRecordings = {...this.state.selectedAdjudicatorRecording};
        adjudicatorRecordings['adjudicator_id'] = selectedOption?selectedOption.id:'';

        this.setState({selectedAdjudicatorRecording: adjudicatorRecordings}, function(){
          this.setState({recordings:[]}, function(){
            this.setState({playing:[]}, function(){
              this.setState({durationAudio: []}, function(){
                this.setState({pos:[]}, function(){
                  this.setState({page:0}, function(){
                    this.setState({total_page:0}, function(){
                      this.setState({countRecording:0}, function(){
                        this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
                      })
                    })
                  })
                });
              });
            });
          });
        });
      // }
    });
    
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log('this recordings', this.state.recordings);
  //   console.log('next recordings', nextState.recordings);
  //   console.log('is equal or not', isEqual(this.state.recordings, nextState.recordings));
  //   if ( isEqual(this.state.recordings, nextProps.recordings) ) {
  //     console.log('this recordings', this.state.recordings);
  //     console.log('next recordings', nextProps.recordings);
  //     console.log('is equal or not', isEqual(this.state.recordings, nextProps.recordings));
  //     return false;
  //   }
  //   // if (this.state.recordings === nextState.recordings){
  //   //   return false;
  //   // }

  //   if( isEqual(this.state.adjudicators, nextProps.adjudicators) ){
  //   // if (this.state.adjudicators === nextState.adjudicators){
  //   //   console.log('if condition');
  //     // console.log('this adjudicator', this.state.adjudicators);
  //     // console.log('next adjudicator', nextProps.adjudicators);
  //     // console.log('is equal or not', isEqual(this.state.adjudicators, nextProps.adjudicators));
  //     return false;
  //   }
  //   return true;
  // }
  
  componentWillReceiveProps(nextProps) {
    
    if (nextProps.adjudicators && !isEqual(this.state.adjudicators, nextProps.adjudicators)){
      this.setState({adjudicators:nextProps.adjudicators});
    }

    if (nextProps.recordings){
      if ( nextProps.recordings.data) {
        /*Logic to compare old data with new not to render again and for lazy loading data push to end of an array*/
        var recordingsTempKeys = Object.keys(nextProps.recordings.data);

        var recordingsTempLen = recordingsTempKeys.length;

        var currentRecordingKeys = Object.keys(this.state.recordings);

        var currentRecordingCount = currentRecordingKeys.length;

        var countTempNewNext = 0;

        if (nextProps.recordings.current_page === 1){
          countTempNewNext = recordingsTempLen;
        } else {
          var multi = (nextProps.recordings.current_page - 1) * nextProps.recordings.per_page;
          countTempNewNext = recordingsTempLen + multi;
        }
        
        if ( countTempNewNext === 0 ){
          this.setState({getRecordingApi:true}, function(){
            this.setState({recordingNotFound:true});  
          });  
        } else {
          this.setState({getRecordingApi:true}, function(){
            this.setState({recordingNotFound:false});
          });
        }

        /*If count is not equal for old recording state and to next prop then it will update recording state*/
        if (!isEqual(currentRecordingCount, countTempNewNext)){
          const recordingsTemp = this.state.recordings;
          const playingTempInitial = {...this.state.playing};
          const durationAudioTemp = {...this.state.durationAudio};
          const posTemp = {...this.state.pos};

          var countTemp = this.state.countRecording;

          for(var i = 0 ; i < recordingsTempLen; i++){
            recordingsTemp.push(nextProps.recordings.data[i]);
            playingTempInitial[countTemp] = false;
            durationAudioTemp[countTemp] = 0;
            posTemp[countTemp] = 0;
            countTemp++;
          }

          this.setState({playing:playingTempInitial}, function(){
            this.setState({durationAudio: durationAudioTemp}, function(){
              this.setState({pos:posTemp}, function(){
                this.setState({recordings:recordingsTemp},  function(){
                  this.setState({countRecording:countTemp}, function(){
                    this.setState({page:nextProps.recordings.current_page}, function(){
                      this.setState({total_page:nextProps.recordings.last_page});
                    });
                  });
                });
              });
            });
          });
        }
      }
    }
  }
  componentDidMount() {
    this.props.getAdudicatorsCall(this.state.musicDirector);
    this.props.getAdudicatorsRecordingsCall(this.state.selectedAdjudicatorRecording, 1);
  }
  render(){
    const { selectedOption, adjudicators, recordings, durationAudio, pos, playing, page, total_page, recordingNotFound, getRecordingApi } = this.state;
    const { loading, musicDirector } = this.props;
    return(
      <section className="first_section">
        <div className="container">
          <div className="row">
            {/*<div className="col-md-12">
              <h2 className="gallery_title">Adjudicator Comments</h2>
            </div>*/}
            <div className="col-md-8">
              <h3 className="view_comments">{musicDirector ? musicDirector.festival.name : 'Festival'}</h3>
            </div>
            <div className="col-md-4">
              {
                adjudicators &&
                <Select
                  value={selectedOption}
                  onChange={this.handleChange}
                  options={adjudicators}
                  getOptionLabel ={(option)=>option.first_name +' '+ option.last_name}
                  getOptionValue ={(option)=>option.id}
                  className="selectAdjudicator"
                  placeholder="Select Adjudicator"
                  isClearable={true}
                />
              }
            </div>
            <div className="col-md-12">
              <div className="comments_container">
                {
                  <div className="all_comments">
                    View Adjudicator Comments

                    {
                      !recordingNotFound &&
                      <button className="download_all" onClick={this.downloadAllFiles} >download all</button>
                    }
                    <div className="clearfix"></div>
                  </div>
                }

                {
                  recordings &&
                  <div>
                    
                    {
                      recordings.map((prop,key)=>{
                        return (
                          <div  className="audio_comment" key={key}>
                            
                            <div className="user_details">
                            {

                              <img src={prop.adjudicator.image_url?prop.adjudicator.image_url:Profile_Icon} alt="ProfileIconImage" />
                            }
                            </div>
                            <div className="play" durationtest={durationAudio[key]} position={pos[key]}>
                                {
                                  !playing[key] &&
                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={play} alt="playImage" /></button>
                                }
                                {
                                  playing[key] &&
                                  <button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={pause} alt="pauseImage" /></button>
                                }
                            </div>

                            <div className="audio_player">
                              <div className="dated">{   moment( moment.utc(prop.created_at).toDate()).local().format('MM/DD/YYYY HH:mm:ss')   } </div>
                              {
                                  prop.comment_url &&
                                 <Wavesurfer
                                  audioFile={prop.comment_url}
                                  pos={pos[key]}
                                  onPosChange={(e)=>this.handlePosChange(e, key)}
                                  playing={playing[key]?true:false}
                                  crossorigin="anonymous"
                                  onFinish={(e)=>this.handleFinish(e, key)}
                                  onReady={(e)=>this.handleLoadingAudio(e,key)}
                                  options= {{height: 65,waveColor: '#e1f0f0',progressColor: '#bcd7e0',cursorColor: '#a3c6cf', width:'100%'}}
                                />
                              }
                              <div className="timer_en" test={durationAudio[key]}>{ moment.duration(durationAudio[key], "seconds").format() }</div>
                              {
                                pos[key] >= 1 &&
                                <div className="timer_st">{ moment.duration(pos[key], "seconds").format() }</div>  
                              }
                              {
                                pos[key] < 1 &&
                                <div className="timer_st">0:00</div>
                              }
                            </div>

                            {
                              prop.is_text_approved == 1 &&
                              <div className="textComments">
                                {/* <button onClick={()=>this.showModalBox(prop.id, prop.comment_text)} ><img src={texticon} alt="Read Comments" width={16}/> Read Text Comments</button> */}
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Read Text Comments</Tooltip>}>
                                  <button className="btn btn-secondary circledBtn" onClick={()=>this.showModalBox(prop.id, prop.comment_text)} title="Read Text Comments">
                                  <i className="fa fa-file-text-o" />
                                  </button>
                                </OverlayTrigger>

                              </div>
                            }

                            <button className="download_btn" onClick={()=>this.downloadFile(prop.comment_url, prop.adjudicator.first_name.concat('_',prop.adjudicator.last_name,'_', key+1))}>download</button>

                            <div style={{width:'100%' }}></div>
                              
                            <p className="comment_name">{prop.adjudicator.first_name +' '+ prop.adjudicator.last_name}</p>
                          </div>
                        )
                      })
                    }
                  </div>
                }
              </div>
              <div style={{textAlign:'center'}}>
                {
                  page < total_page  &&
                  <button className="load_more_btn" onClick={()=>this.getNextPageData(this.state.page+1)} >Load More</button>
                }
                {
                  !loading && recordingNotFound && getRecordingApi &&
                  <div>
                    <div className="clearfix" ></div>
                    <div className="well well-sm" style={{marginTop:'15px'}}>
                      <h3>Record Not Found!</h3>
                    </div>
                  </div>
                }

                { loading &&
                  <ReactLoading type="bars" color="#1DC7EA" height={5} width={40} />  
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return ({
    getAdudicatorsCall  : (musicDirectorData) => { dispatch(musicDirectorActions.getAdudicators(musicDirectorData)) },
    getAdudicatorsRecordingsCall  : (adjudicatorRecordingsObject, page) => { dispatch(musicDirectorActions.getAdudicatorsRecordings(adjudicatorRecordingsObject, page)) }
  });
};

function mapStateToProps(state) {
  const { adjudicators, loading, musicDirector, recordings } = state.musicDirectorReducer;
  // console.log('state AdjudicatorComments', state);
  return {
    adjudicators,loading, musicDirector, recordings
  };
}

const AdjudicatorComments = connect(mapStateToProps, mapDispatchToProps)(AdjudicatorCommentsPage);
export default AdjudicatorComments;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/AdjudicatorComments.jsx